import React from 'react';
import { apiPost } from '../../../../../services/apiClient';
import TextInput from '../../../../../controls/textInput.jsx';

export default class DocumentCommentCell extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            value: this.props.value,
			error: null,
			isBusy: false,
			isEdit: false
        };
    }

    componentWillReceiveProps(newProps) {
        this.setState({ value: newProps.value });
    }

	handleCommentChange(newValue) {
		this.setState({ value: newValue });
	}

	handleCommentEditComplete() {
		this.setState({ isBusy: true });
		let request = {
			comment: this.state.value
		};
		apiPost("parcels/documents/" + this.props.parcelId + "/file/" + this.props.documentId + "/comment", request)
			.then(() => {
				this.setState({
					error: null,
					isBusy: false,
					isEdit: false
				});
			})
			.catch(err => {
				let error = err.messages ? err.messages.comment : null;
				this.setState({
					error: error,
					isBusy: false
				});
			});
	}

	enableEditState() {
		if (this.props.isEditable) {
			this.setState(
				{ isEdit: true }, 
				() => {
					$('#parcelDocumentCommentEditor').focus();
				}
			);
		}
	}

	renderLabel() {
		return (
			<td onClick={() => this.enableEditState()}>
				<div>{this.state.value}</div>
			</td>
		);
	}

	renderEditor() {
		return (
			<td className={"form-group" + (this.state.error ? " has-error" : "")}>
				<TextInput id="parcelDocumentCommentEditor"
					title={this.state.error}
					value={this.state.value}
					onChange={value => this.handleCommentChange(value)}
					onEditComplete={() => this.handleCommentEditComplete()}
					disabled={this.state.isBusy}
				/>
			</td>
		);
	}

	render() {
		if (this.state.isEdit) {
			return this.renderEditor();
		} else {
			return this.renderLabel();
		}
	}
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form/tabs/controls/docCommentCell.jsx